// For web, use the Firebase web SDK
import { DocumentSnapshot, Firestore, QueryDocumentSnapshot } from 'firebase/firestore'

export {
  collection,
  doc,
  getDoc,
  getDocs,
  setDoc,
  updateDoc,
  deleteDoc,
  query,
  where,
  writeBatch,
  onSnapshot,
  addDoc,
  orderBy,
  limit,
  startAfter,
  startAt,
  endAt,
  endBefore,
  serverTimestamp,
  type Unsubscribe,
} from 'firebase/firestore'

// Web-specific type compatibility
export type FirebaseFirestoreTypes = {
  Module: Firestore
  DocumentSnapshot: DocumentSnapshot
  QuerySnapshot: QueryDocumentSnapshot
}
